(function() {
	$('.ccm-mobile-settings').click(function(e) {
		e.preventDefault();
		$(this).hide();
		$('.ccm-action--accept-selected').css('display', 'inline-block');
		$('.ccm-checkboxes').css('display', 'flex');
	})
})();
